import { fbDB } from "../config/firebase";
import { SESSION_ADD, SESSION_WATCH_ON } from "./types";

export const sessionAdd = sName => async dispatch => {
  fbDB
    .ref("/session")
    .set({
      name: sName
    })
    .then(() => {
      return dispatch({
        type: SESSION_ADD,
        payload: null
      });
    })
    .catch(err => {
      console.log(err);
    });
};

export const sessionWatchOn = () => async dispatch => {
  fbDB.ref("/session").on("value", snapshot =>
    dispatch({
      type: SESSION_WATCH_ON,
      payload: snapshot.val()
    })
  );
};

export const sessionWatchOff = () => async dispatch => {
  fbDB.ref("/session").off();
};
